import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import useTimerProgress from '@/features/poker-table/hooks/useTimerProgress';

const colorClasses = {
  'ph-purple': 'bg-ph-purple',
  'ph-green': 'bg-ph-green',
  'ph-orange': 'bg-ph-orange',
  'ph-red': 'bg-ph-red',
};

interface UserPanelTimerProps {
  timer?: number;
  timeRemaining?: number;
  usingTimeBank?: boolean;
}

const UserPanelTimer: FC<UserPanelTimerProps> = ({ timer, timeRemaining, usingTimeBank }) => {
  const { progressBarWidth, progressColor } = useTimerProgress({
    timer,
    timeRemaining,
    usingTimeBank,
  });

  if (timer === undefined || timeRemaining === undefined) {
    return null;
  }

  return (
    <div className="mx-1 h-2 min-w-18 flex-1 rounded-full bg-ph-black">
      <div className="h-2 w-full rounded-full bg-ph-white-10">
        <div
          className={twMerge(progressColor ? colorClasses[progressColor] : '', 'h-full rounded-full')}
          style={{ width: progressBarWidth }}
        />
      </div>
    </div>
  );
};

export default UserPanelTimer;
